import React, { useState, useEffect } from 'react'
import './ResetPassword.css'
import logo from '../asset/image/forgot.png'
import { Form, Button } from 'react-bootstrap'
import { useParams } from 'react-router-dom'
import { resetPassword } from '../Network/Authentication'
import { Loading } from '../Library'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { setDocumentTitle } from '../AppTitle'

function ResetPassword() {
    const { hash } = useParams()
    const [isFinish, setFinish] = useState(false);
    const [isLoading, setLoading] = useState("");
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('')
    const [error, setError] = useState("")

    const onSubmit = () =>{
        setLoading(true);
        resetPassword(hash, newPassword, confirmPassword,
            ()=>{
                setLoading(false)
                setFinish(true)
            },
            (error)=>{
                setLoading(false)
                if(error.response !== undefined){
                    setError(error.response.data.message)
                }else{
                    setError(error.message)
                }
            })
    }

    useEffect(()=>{
        setDocumentTitle("Reset Password")
    },[])

    return (
        <>
        { isLoading ? <Loading title="Reseting password"/>: null }
        <div id="reset-password">
            <div>
                <div id="container">
                    { !isFinish ?
                    <>
                    <div className="logo-container">
                        <img src={logo} className="logo" alt="logo"/>
                    </div>
                    
                    <div className="title">
                        <b>Enter new Password</b>
                    </div>
                    <Form
                    onSubmit={(e)=>{
                        e.preventDefault()
                        onSubmit()
                    }}
                    >
                        <Form.Control
                        placeholder="New password"
                        className="input-form"
                        type="password"
                        value={newPassword}
                        onChange={(e)=>setNewPassword(e.target.value)}
                        required
                        />
                        <Form.Control
                        placeholder="Confirm password"
                        className="input-form"
                        type="password"
                        value={confirmPassword}
                        onChange={(e)=>setConfirmPassword(e.target.value)}
                        required
                        />
                        { error !== "" ?
                        <div className="error-text">
                            {error}
                        </div>
                        : null
                        }
                        <Button type="submit" className="submit-button">
                            Change password
                        </Button>
                    </Form>
                    </>:
                    <div id="finish-reset">
                        <FontAwesomeIcon icon={faCheckCircle} className="icon"/>
                        <div className="title">Reset successful</div>
                        <div className="desc">
                            Your account has reset password you can login with new password.
                        </div>
                    </div>
                    }
                </div>
            </div>
            
        </div>
        </>
    )
}

export default ResetPassword
